import Mcard1 from "../../resources/teachersCard/MALE/Bond/cover.jpg";
import Mcard1_2 from "../../resources/teachersCard/MALE/Bond/main.jpg";
import Mcard1_3 from "../../resources/teachersCard/MALE/Bond/blank.jpg";

import Mcard2 from "../../resources/teachersCard/MALE/FilmyDosti/cover.jpg";
import Mcard2_2 from "../../resources/teachersCard/MALE/FilmyDosti/main.jpg";
import Mcard2_3 from "../../resources/teachersCard/MALE/FilmyDosti/blank.jpg";

import Mcard3 from "../../resources/teachersCard/MALE/FindingX/cover.jpg";
import Mcard3_2 from "../../resources/teachersCard/MALE/FindingX/main.jpg";
import Mcard3_3 from "../../resources/teachersCard/MALE/FindingX/blank.jpg";

import Mcard4 from "../../resources/teachersCard/MALE/Lunch/cover.jpg";
import Mcard4_2 from "../../resources/teachersCard/MALE/Lunch/main.jpg";
import Mcard4_3 from "../../resources/teachersCard/MALE/Lunch/blank.jpg";

import Mcard5 from "../../resources/teachersCard/MALE/Momos/cover.jpg";
import Mcard5_2 from "../../resources/teachersCard/MALE/Momos/main.jpg";
import Mcard5_3 from "../../resources/teachersCard/MALE/Momos/blank.jpg";

import Mcard6 from "../../resources/teachersCard/MALE/PehleMai/cover.jpg";
import Mcard6_2 from "../../resources/teachersCard/MALE/PehleMai/main.jpg";
import Mcard6_3 from "../../resources/teachersCard/MALE/PehleMai/blank.jpg";

import Mcard7 from "../../resources/teachersCard/MALE/Punishment/cover.jpg";
import Mcard7_2 from "../../resources/teachersCard/MALE/Punishment/main.jpg";
import Mcard7_3 from "../../resources/teachersCard/MALE/Punishment/blank.jpg";

import Mcard8 from "../../resources/teachersCard/MALE/Sleeping/cover.jpg";
import Mcard8_2 from "../../resources/teachersCard/MALE/Sleeping/main.jpg";
import Mcard8_3 from "../../resources/teachersCard/MALE/Sleeping/blank.jpg";

import Mcard9 from "../../resources/teachersCard/MALE/SurpriseTest/cover.jpg";
import Mcard9_2 from "../../resources/teachersCard/MALE/SurpriseTest/main.jpg";
import Mcard9_3 from "../../resources/teachersCard/MALE/SurpriseTest/blank.jpg";

import Mcard10 from "../../resources/teachersCard/MALE/TeachersDay/cover.jpg";
import Mcard10_2 from "../../resources/teachersCard/MALE/TeachersDay/main.jpg";
import Mcard10_3 from "../../resources/teachersCard/MALE/TeachersDay/blank.jpg";

import Mcard11 from "../../resources/teachersCard/MALE/HumseBetterartistkahan/cover.jpg";
import Mcard11_2 from "../../resources/teachersCard/MALE/HumseBetterartistkahan/main.jpg";
import Mcard11_3 from "../../resources/teachersCard/MALE/HumseBetterartistkahan/blank.jpg";

import Mcard12 from "../../resources/teachersCard/MALE/PenFight/cover.jpg";
import Mcard12_2 from "../../resources/teachersCard/MALE/PenFight/main.jpg";
import Mcard12_3 from "../../resources/teachersCard/MALE/PenFight/blank.jpg";


import fcard1 from "../../resources/Female/Bond/cover.jpg";
import fcard1_2 from "../../resources/Female/Bond/main.jpg";
import fcard1_3 from "../../resources/Female/Bond/blank.jpg";

import fcard2 from "../../resources/Female/FilmyDosti/cover.jpg";
import fcard2_2 from "../../resources/Female/FilmyDosti/main.jpg";
import fcard2_3 from "../../resources/Female/FilmyDosti/blank.jpg";

import fcard3 from "../../resources/Female/FindingX/cover.jpg";
import fcard3_2 from "../../resources/Female/FindingX/main.jpg";
import fcard3_3 from "../../resources/Female/FindingX/blank.jpg";

import fcard4 from "../../resources/Female/Lunch/cover.jpg";
import fcard4_2 from "../../resources/Female/Lunch/main.jpg";
import fcard4_3 from "../../resources/Female/Lunch/blank.jpg";

import fcard5 from "../../resources/Female/Momos/cover.jpg";
import fcard5_2 from "../../resources/Female/Momos/main.jpg";
import fcard5_3 from "../../resources/Female/Momos/blank.jpg";

import fcard11 from "../../resources/Female/BetterArtist/cover.jpg";
import fcard11_2 from "../../resources/Female/BetterArtist/main.jpg";
import fcard11_3 from "../../resources/Female/BetterArtist/blank.jpg";

import fcard7 from "../../resources/Female/Punishment/cover.jpg";
import fcard7_2 from "../../resources/Female/Punishment/main.jpg";
import fcard7_3 from "../../resources/Female/Punishment/blank.jpg";

import fcard8 from "../../resources/Female/Sleeping/cover.jpg";
import fcard8_2 from "../../resources/Female/Sleeping/main.jpg";
import fcard8_3 from "../../resources/Female/Sleeping/blank.jpg";

import fcard9 from "../../resources/Female/SurpriseTest/cover.jpg";
import fcard9_2 from "../../resources/Female/SurpriseTest/main.jpg";
import fcard9_3 from "../../resources/Female/SurpriseTest/blank.jpg";

import fcard10 from "../../resources/Female/TeachersDay/cover.jpg";
import fcard10_2 from "../../resources/Female/TeachersDay/main.jpg";
import fcard10_3 from "../../resources/Female/TeachersDay/blank.jpg";

import fcard6 from "../../resources/Female/PehleMai/cover.jpg";
import fcard6_2 from "../../resources/Female/PehleMai/main.jpg";
import fcard6_3 from "../../resources/Female/PehleMai/blank.jpg";

import fcard12 from "../../resources/Female/PenFight/cover.jpg";
import fcard12_2 from "../../resources/Female/PenFight/main.jpg";
import fcard12_3 from "../../resources/Female/PenFight/blank.jpg";


export const male = [
  
  { coverImg: Mcard1, firstImg: Mcard1_2, secondImg: Mcard1_3,class:"m1" },
  { coverImg: Mcard2, firstImg: Mcard2_2, secondImg: Mcard2_3,class:"m2"},
  { coverImg: Mcard3, firstImg: Mcard3_2, secondImg: Mcard3_3,class:"m3"},
  { coverImg: Mcard4, firstImg: Mcard4_2, secondImg: Mcard4_3,class:"m4"},
  { coverImg: Mcard5, firstImg: Mcard5_2, secondImg: Mcard5_3,class:"m5"},
  { coverImg: Mcard6, firstImg: Mcard6_2, secondImg: Mcard6_3,class:"m6"},
  { coverImg: Mcard7, firstImg:Mcard7_2, secondImg: Mcard7_3,class:"m7"},
  { coverImg: Mcard8, firstImg: Mcard8_2, secondImg: Mcard8_3,class:"m8"},
  { coverImg: Mcard9, firstImg: Mcard9_2, secondImg: Mcard9_3,class:"m9"},
  // { coverImg: Mcard10, firstImg:Mcard10_2, secondImg: Mcard10_3,class:"m10"},
  { coverImg: Mcard11, firstImg:Mcard11_2, secondImg: Mcard11_3,class:"m11"},
]




export const female = [
  { coverImg: fcard1, firstImg: fcard1_2, secondImg: fcard1_3,class:"f1"},
  { coverImg: fcard2, firstImg: fcard2_2, secondImg: fcard2_3,class:"f2"},
  { coverImg: fcard3, firstImg: fcard3_2, secondImg: fcard3_3,class:"f3"},
  { coverImg: fcard4, firstImg: fcard4_2, secondImg: fcard4_3,class:"f4"},
  { coverImg: fcard5, firstImg: fcard5_2, secondImg: fcard5_3,class:"f5"},
  { coverImg: fcard6, firstImg: fcard6_2, secondImg: fcard6_3,class:"f6"},
  { coverImg: fcard7, firstImg: fcard7_2, secondImg: fcard7_3,class:"f7"},
  { coverImg: fcard8, firstImg: fcard8_2, secondImg: fcard8_3,class:"f8"},
  { coverImg: fcard9, firstImg: fcard9_2, secondImg: fcard9_3,class:"f9"},
  // { coverImg: fcard10, firstImg: fcard10_2, secondImg: fcard10_3,class:"f10"},
  { coverImg: fcard11, firstImg: fcard11_2, secondImg: fcard11_3,class:"f11"},
];






export const maleAppView = [
  

  { coverImg: Mcard4, firstImg: Mcard4_2, secondImg: Mcard4_3,class:"m4"},  
  { coverImg: Mcard5, firstImg: Mcard5_2, secondImg: Mcard5_3,class:"m5"},   
  { coverImg: Mcard6, firstImg: Mcard6_2, secondImg: Mcard6_3,class:"m6"},   
  
  { coverImg: Mcard8, firstImg: Mcard8_2, secondImg: Mcard8_3,class:"m8"},  

  { coverImg: Mcard10, firstImg:Mcard10_2, secondImg: Mcard10_3,class:"m10"},
  { coverImg: Mcard12, firstImg:Mcard12_2, secondImg: Mcard12_3,class:"m12"}, 
 
]




export const femaleAppView = [

  { coverImg: fcard4, firstImg: fcard4_2, secondImg: fcard4_3,class:"f4"},  
  { coverImg: fcard5, firstImg: fcard5_2, secondImg: fcard5_3,class:"f5"},  
  { coverImg: fcard6, firstImg: fcard6_2, secondImg: fcard6_3,class:"f6"},   
  
  { coverImg: fcard8, firstImg: fcard8_2, secondImg: fcard8_3,class:"f8"},  

  { coverImg: fcard10, firstImg: fcard10_2, secondImg: fcard10_3,class:"f10"}, 
  { coverImg: fcard12, firstImg: fcard12_2, secondImg: fcard12_3,class:"f12"}, 

];







